<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-5" [model]="breadcrumbs"></p-breadcrumb>

    <div class="dashboard-header flex-row">
        <div>
            <div class="dashboard-header__title">Accounting Dashboard</div>
        </div>
        <div class="filler"></div>
        <div>
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        (onSelect)="changeDateRange()" [(ngModel)]="selectedDateRange" selectionMode="range" 
                        [readonlyInput]="true" [showIcon]="true"></p-calendar>
        </div>
    </div>

    <section class="dashboard-section-flex flex-space-between mt-3">
        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card mr-2">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Revenue</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-total">{{accountingDashboard.TotalRevenue}}</div>
                <div class="statistic-title mb-3">Total Revenue</div>
                <p-chart [type]="'line'"
                         [data]="totalRevenueChartData"
                         [options]="totalRevenueChartOptions"></p-chart>
            </div>
        </div>

        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card mr-2">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Expenses</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-total">{{accountingDashboard.TotalExpenses}}</div>
                <div class="statistic-title mb-3">Total Expenses</div>
                <p-chart [type]="'line'"
                         [data]="totalExpensesChartData"
                         [options]="totalExpensesChartOptions"></p-chart>
            </div>
        </div>

        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Profit</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-total">{{accountingDashboard.TotalProfit}}</div>
                <div class="statistic-title mb-3">Total Profit</div>
                <p-chart [type]="'line'"
                         [data]="totalProfitChartData"
                         [options]="totalProfitChartOptions"></p-chart>
            </div>
        </div>
    </section>

    <section class="dashboard-section-flex mt-3">
        <div class="dashboard-col-md-12">
            <div class="service-type-dashboard-card">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Cashflow</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <p-chart [data]="totalCashflowChartData"
                         [options]="totalCashflowChartOptions"></p-chart>
            </div>
        </div>
    </section>

    <section class="dashboard-section-flex flex-space-between mt-3">
        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card mr-2">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Transaction Volume</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-total">{{accountingDashboard.TotalTransactionVolume}}</div>
                <div class="statistic-title mb-3">Total Transaction Volume and Transaction Volume</div>
                <p-chart [data]="totalTransactionVolumeChartData"
                         [options]="totalTransactionVolumeChartOptions"></p-chart>
            </div>
        </div>

        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card mr-2">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Payment Method</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <p-chart type="pie" [data]="totalPaymentMethodChartData"
                         [options]="totalPaymentMethodChartOptions"></p-chart>
            </div>
        </div>

        <div class="dashboard-col-md-4">
            <div class="service-type-dashboard-card">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Order Distribution</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-total mb-3">{{accountingDashboard.OrderDistributionCount}}</div>
                <p-chart [data]="totalOrderDistributionChartData"
                         [options]="totalOrderDistributionChartOptions"></p-chart>
            </div>
        </div>
    </section>
</div>
